export default "__VITE_ASSET__4625aa2c__"